/* Svensk katalog for locale-advisor-costs-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'adv.cost.review': 'Granska',
  'adv.cost.moreTitle': 'Fler möjligheter',
  'adv.cost.observedValue': 'Observerat värde',
  'adv.cost.invoiceBasis': 'Faktureringsunderlag',
  'adv.cost.draftValue': 'Utkastvärde',
  'adv.cost.possibleCount': 'Möjliga dubbletter',
  'adv.cost.purchaseShare': 'Inköpsandel',
  'adv.cost.givenDiscount': 'Lämnad rabatt',
  'adv.cost.unbilledNote': 'Faktureringsunderlag, inte bokförd intäkt',
  'adv.cost.draftNote': 'Utkastvärde, inte bokförd intäkt',
  'adv.cost.acceptedNote': 'Accepterade offerter utan kopplad faktura',
  'adv.cost.duplicateNote': 'Möjliga dubbletter som måste kontrolleras',
  'adv.cost.supplierNote': 'Inköpsvolym som kan ge underlag för förhandling',
  'adv.cost.discountTitle': 'Gå igenom de rabatter som lämnats',
  'adv.cost.discountNote': 'Faktiskt lämnad rabatt, inte beräknad besparing',
  'adv.cost.voucherNote': 'Dokumentation som måste följas upp; ingen beräknad besparing',
  'adv.cost.followUp': 'Att följa upp',
  'adv.cost.increaseToReview': 'Ökning att undersöka',
  'adv.cost.fixedTitle': 'Bokförda fasta kostnader',
  'adv.cost.tryAdjustment': 'Prova en justering',
  'adv.cost.fixedDetail': 'Snitt per månad, baserat på {months} hela månader',
  'adv.cost.otherTitle': 'Största övriga kostnadskonton',
  'adv.cost.otherIntro': 'Andelen visar bokförd kostnad mot omsättning under valt år. Den är ingen besparingsuppskattning, och kontot klassificeras inte automatiskt som rörligt.',
  'adv.cost.otherDetail': '{amount} bokfört under valt år',
  'adv.cost.ofRevenue': 'av omsättningen',
  'adv.cost.noRevenueShare': 'Andel inte beräknad',
  'adv.cost.sub': 'Största bokförda kostnadskonton och förändring mot föregående år',
  'adv.cost.subPeriod': 'Största bokförda kostnadskonton och förändring mot samma period föregående år',
  'adv.cost.help': 'Kontona kommer från resultatrapporten för valt år. Staplarna visar bokfört belopp per konto. Förändring visas bara när samma konto har ett positivt belopp föregående år.',
  'adv.cost.helpPeriod': 'Kontona kommer från resultatrapporten till och med innevarande månad. Staplarna visar bokfört belopp per konto. Förändringen jämförs med samma period föregående år när kontot hade ett positivt belopp.',
  'adv.cost.rowHelp': 'Bokfört på kontot: {amount} under valt år. Förändring mot föregående år: {change}.',
  'adv.cost.noComparison': 'Inga siffror från föregående år',
  'adv.cost.emptyText': 'Inga bokförda kostnadskonton under valt år.',
  'adv.cost.flagText': '{name} har ökat betydligt jämfört med föregående år. Kontrollera om förändringen är planerad och gå igenom konteringarna på kontot.',
  'adv.why.costSub': 'Kostnadskonton som har ökat betydligt jämfört med föregående år',
});
